import * as Cookies from 'js-cookie';
import moment from 'moment'
import {get} from 'lodash';

import Notification from '../components/Notification';

export const COOKIES_KEY_NOTIFICATION = '_archadmin_notification'
export const CSRF_TOKEN = document.querySelector('meta[name="csrf-token"]').getAttribute('content')

export const addNotification = (data) => {
  Cookies.set(COOKIES_KEY_NOTIFICATION, JSON.stringify(data))
}

export const userTypes = {
  'deleted': 'Deleted',
  'normal': 'Normal',
  'popular': 'Popular',
  'recommend': 'Recommend',
  'vip': 'Vip',
  'kenta': 'Penalty History',
  'admin': 'Admin'
}

export const availableBanTimes = [
  {
    key: '3600',
    value: '1 hour',
  },
  {
    key: '86400',
    value: '24 hours',
  },
  {
    key: '604800',
    value: '7 days',
  },
  {
    key: '2592000',
    value: '30 days',
  },
  {
    key: 'specific',
    value: 'specific time',
  },
]

export const metaLoading = {
  meta: {
    isLoading: false,
    isFullyLoaded: false,
    per: 5,
    page: 1,
  },
}

export const _setUntil = (until) => {
  const now = moment()

  if (!until || moment(until).isBefore(now)) {
    return now.format('YYYY-MM-DD HH:mm')
  }

  return moment(until).format('YYYY-MM-DD HH:mm')
}

export const requestCallback = (request, redirect_url, reload) => {
  request
    .then((res) => {
      if (res.status == 200 && get(res, 'data.message')) {
        addNotification({
          message: get(res, 'data.message'),
          type: Notification.NOTIFICATION_TYPES.success,
        })
      }
    })
    .catch((error) => {
      addNotification({
        message: get(error, 'response.data.message'),
        type: Notification.NOTIFICATION_TYPES.error,
      })
    })
    .then(() => { redirect_url !== undefined && !reload ?
      window.location = redirect_url
    :
      window.location.reload()
    })
}

export const searchkickDisabled = () => {
  return gon.currentProvider === 'chatparty' || gon.currentProvider === 'lesbianchat'
}

export const noteDisabled = () => {
  return false
}

export const createDownloadableLink = (link) => {
  try {
    return `${link}${window.location.search}`
  } catch (e) {
    return link
  }
}
